import { FilmComponent } from "../FilmComponent/FilmComponent"
import { GalleryComponent2 } from "../Gallery/GalleryComponent2"
import { june2026Photos } from "../Gallery/LabPhotos/june2026/june2026Photos"

import "./LabText.scss"

export const June2026 = () => {
	return (
		<div className='june2026'>
			<h2 className='LabTitle'>Semestr 2</h2>
			<p className='LabText2'>
				W drugim półroczu roku szkolnego 2025/2026 w ramach realizacji programu
				„Laboratoria Przyszłości” kontynuowano rozwijanie kompetencji
				przyszłości wśród uczniów poprzez wykorzystanie nowoczesnych technologii
				oraz metod nauczania opartych na doświadczeniu i kreatywności.
				Wykorzystywano zakupiony sprzęt: drukarkę 3D, aparat fotograficzny oraz
				zestawy klocków LEGO. Sprzęt był używany podczas zajęć lekcyjnych oraz
				na zajęciach dodatkowych. Drukarka 3D była wykorzystywana podczas lekcji
				informatyki, techniki i zajęć z wychowawcą. Projektowane przedmioty
				stanowiły doskonałe prezenty dla członków rodziny czy kolegów,
				koleżanek. Dzięki pracy z drukarką 3D uczniowie rozwijali wyobraźnię
				przestrzenną, umiejętności projektowania oraz logicznego myślenia.
			</p>
			<p className='LabText2'>
				Wykorzystanie aparatu rozwijało wrażliwość estetyczną uczniów oraz
				umiejętność dokumentowania swojej pracy. Uczniowie nagrywali scenki na
				zajęciach językowych, analizowali je pod kontem uniknięcia błędów
				podczas wypowiadania się. Aparat wykorzystany był podczas dokumentowania
				zajęć a także imprez szkolnych.
			</p>
			<p className='LabText2'>
				Klocki LEGO wykorzystywane były na rewalidacji, na lekcjach techniki.
				Dzięki nim uczniowie rozwijali kreatywność oraz kompetencje techniczne,
				uczyły się współpracy i wytrwałości. Sprzęt pozyskany w ramach programu
				„Laboratoria Przyszłości” umożliwił prowadzenie atrakcyjnych zajęć
				rozwijających kompetencje przyszłości oraz wspierał naukę poprzez
				praktyczne działanie. Program przyczynił się do zwiększenia aktywności
				uczniów oraz rozwijania ich zainteresowań technologicznych i
				kreatywnych.
			</p>
			<GalleryComponent2 carouselId='june2026Photos' images={june2026Photos} />
		</div>
	)
}
